import {InertiaForm, useForm} from '@inertiajs/vue3';
import {TaskFeedback} from '../types/entities/tasks';
import {Ref} from 'vue';
import Rubric = App.DTOs.Rubrics.Rubric;
import TaskCriterionGradeDto = App.DTOs.Entities.Grades.TaskCriterionGradeDto;
import ManualGradingSubmissionDto = App.DTOs.AssignmentMarking.ManualGradingSubmissionDto;
import PartRubric = App.DTOs.Rubrics.PartRubric;
import {scaleGradeToPoints} from '../util/grades';

export function useDataDrivenOverrideForm(
  rubric: Ref<Rubric>,
  feedbacks: Ref<TaskFeedback[]>,
  grades: Ref<TaskCriterionGradeDto[]>
): InertiaForm<ManualGradingSubmissionDto> {
  return useForm(() => {
    if (!rubric.value) {
      return {
        parts: [],
      };
    }

    function gradeForPart(grade: TaskCriterionGradeDto, partRubric: PartRubric) {
      if (!grade.part && !grade.blockId) {
        return false;
      }

      if (grade.blockId) {
        return (
          grade.blockId === partRubric.blockId && grade.criterionName === partRubric.criterionName
        );
      }

      return grade.part === partRubric.partName;
    }

    function feedbacksForPart(feedback: TaskFeedback, partRubric: PartRubric) {
      if (!feedback.partName && !feedback.blockId) {
        return false;
      }

      if (feedback.blockId) {
        return (
          feedback.blockId === partRubric.blockId &&
          feedback.criterionName === partRubric.criterionName
        );
      }

      return feedback.partName === partRubric.partName;
    }

    let generalFeedbackText = feedbacks.value
      .filter((feedback) => !feedback.blockId && !feedback.partName)
      .map((feedback) => feedback.content.trim())
      .filter((text) => !!text)
      .join('\r\n');

    return {
      parts: [
        {
          blockId: null,
          criterionName: null,
          label: 'General',
          pointsAvailable: 0, // There's no "general grade", just feedback
          pointsEarned: 0,
          feedback: generalFeedbackText ? [generalFeedbackText] : [],
        },
        ...rubric.value.parts.map((partRubric) => {
          let grade = grades.value.find((grade) => gradeForPart(grade, partRubric));
          let pointsAvailable = partRubric.pointsAvailable || 0;
          let pointsEarned = scaleGradeToPoints(grade, pointsAvailable);

          let feedbackText = feedbacks.value
            .filter((feedback) => feedbacksForPart(feedback, partRubric))
            .map((feedback) => feedback.content)
            .filter((text) => !!text)
            .join('\r\n');

          return {
            blockId: partRubric.blockId,
            criterionName: partRubric.criterionName,
            label: partRubric.label,
            pointsAvailable,
            pointsEarned,
            feedback: feedbackText ? [feedbackText] : [],
          };
        }),
      ],
    };
  });
}
